import React, {Component} from 'react';
import Header from './../Layout/Header';
import Footer from './../Layout/Footer2';
import { Helmet } from 'react-helmet';
import ByCity from './../Element/ByCity';

class AllJobsByCity extends Component {
    render() {
        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Remote Jobs by City | Work From Home Opportunities in USA | OpenToWorkRemote</title>
                    <meta name="description" content="Find remote jobs and work from home opportunities in major USA cities. Search remote positions by city, including New York, Los Angeles, Chicago, and more. Updated daily. #RemoteWork #WorkFromHome" />
                    <meta name="keywords" content="remote jobs by city, work from home USA cities, remote work opportunities by city, remote positions USA, remote career cities, remote employment locations, virtual jobs by city" />
                    <meta property="og:title" content="Remote Jobs by City | OpenToWorkRemote" />
                    <meta property="og:description" content="Find remote jobs and work from home opportunities in major USA cities. Search remote positions by city." />
                    <link rel="canonical" href="https://www.opentoworkremote.com/all-jobs-by-city" />
                </Helmet>

                <ByCity />

                <Footer />
            </div>
        );
    }
};

export default AllJobsByCity;
